"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _v14PagesRouter = require("@mui/material-nextjs/v14-pagesRouter");
var _document = require("next/document");
var _constants = require("../constants");
var _renderThirdPartyScripts = require("../internals/renderThirdPartyScripts");
var _CanonicalLink = require("./CanonicalLink");
var _FaviconLink = require("./FaviconLink");
var _FontsLink = require("./FontsLink");
var _LanguagesMetadata = require("./LanguagesMetadata");
var _OutdatedBrowserInfo = require("./OutdatedBrowserInfo");
var _PreconnectLinks = require("./PreconnectLinks");
var _jsxRuntime = require("react/jsx-runtime");
function DocumentBody({
  servicesUrls,
  thirdPartyConfiguration,
  thirdPartyConfigurationBaidu,
  environment,
  documentBuiltAt,
  language,
  languagesForMetadata,
  hostname,
  publicPathname,
  clientApplicationInsightsConfig,
  tenant,
  emotionStyleTags
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_document.Html, {
    lang: language,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_document.Head, {
      children: [(0, _renderThirdPartyScripts.renderDidomi)(thirdPartyConfiguration?.didomi), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "documentBuiltAt",
        content: documentBuiltAt
      }), clientApplicationInsightsConfig ? /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
        // eslint-disable-next-line react/no-danger -- we have to set this up this way. This is mainly for sharing one config with ASMS and SPAs
        dangerouslySetInnerHTML: {
          __html: `window.oriAppInsightsSettings = JSON.parse(\`${JSON.stringify(clientApplicationInsightsConfig)}\`)`
        }
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreconnectLinks.PreconnectLinks, {
        servicesUrls: servicesUrls,
        thirdPartyConfiguration: thirdPartyConfiguration
      }), !!languagesForMetadata && !!publicPathname && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LanguagesMetadata.LanguagesMetadata, {
        languages: languagesForMetadata,
        host: hostname,
        pathname: publicPathname
      }), !!servicesUrls?.staticStorage.baseUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaviconLink.FaviconLink, {
        version: _constants.DEFAULT_FAVICON_VERSION,
        staticStorageUrl: servicesUrls.staticStorage.baseUrl
      }), !!servicesUrls?.staticStorage.baseUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FontsLink.FontsLink, {
        version: _constants.DEFAULT_FONTS_VERSION,
        staticStorageUrl: servicesUrls.staticStorage.baseUrl
      }), !!publicPathname && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CanonicalLink.CanonicalLink, {
        host: hostname,
        pathname: publicPathname
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_v14PagesRouter.DocumentHeadTags, {
        emotionStyleTags: emotionStyleTags
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("body", {
      children: [!!environment && !!tenant && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutdatedBrowserInfo.OutdatedBrowserInfo, {
        environment: environment,
        language: language,
        servicesUrls: servicesUrls,
        tenant: tenant
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_document.Main, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_document.NextScript, {}), !!environment && (0, _renderThirdPartyScripts.renderThirdPartyScripts)({
        thirdPartyConfiguration,
        thirdPartyConfigurationBaidu,
        environment,
        clientAppsUrl: servicesUrls?.clientApps.baseUrl
      })]
    })]
  });
}
var _default = exports.default = DocumentBody;
